import { render, staticRenderFns } from "./class_schedule.vue?vue&type=template&id=643ed281"
import script from "./class_schedule.vue?vue&type=script&lang=js"
export * from "./class_schedule.vue?vue&type=script&lang=js"
import style0 from "./class_schedule.vue?vue&type=style&index=0&id=643ed281&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports